/*
 * Copyright Mimic Networks, Inc. 2025.
 */
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';

import './WindowsSystemRequirements.css';

export function WindowsSystemRequirements() {
  const { t } = useMimicTranslation('downloadNode');

  return (
    <div className="windows-system-requirements">
      <div>
        <Text strong>{t('systemRequirements.operatingSystem.label')}</Text>{' '}
        <Text>{t('systemRequirements.operatingSystem.value')}</Text>
      </div>
      <div>
        <Text strong>{t('systemRequirements.adminAccess.label')}</Text>{' '}
        <Text>{t('systemRequirements.adminAccess.value')}</Text>
      </div>
      <div>
        <Text strong>{t('systemRequirements.diskSpace.label')}</Text>{' '}
        <Text>{t('systemRequirements.diskSpace.value')}</Text>
      </div>
    </div>
  );
}
